/** Client-safe lifecycle presentation (mirrors the backend deriveLifecycle). */

export type Lifecycle = 'admin' | 'direct_client' | 'freemium'

export const LIFECYCLE_LABELS: Record<Lifecycle, string> = {
  freemium: 'Freemium',
  direct_client: 'Direct client',
  admin: 'Admin',
}

const LIFECYCLE_BADGE: Record<Lifecycle, string> = {
  freemium: 'bg-muted text-muted-foreground',
  direct_client: 'bg-emerald-500/10 text-emerald-600',
  admin: 'bg-violet-500/10 text-violet-600',
}

export function LifecycleBadge({ lifecycle }: { lifecycle: Lifecycle }) {
  return (
    <span
      className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${LIFECYCLE_BADGE[lifecycle]}`}
    >
      {LIFECYCLE_LABELS[lifecycle]}
    </span>
  )
}
